import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteConfirmationData } from '../../../models/delete-confirmation-data';

@Component({
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  standalone: false
})
export class DeleteConfirmationComponent {
  public displayText = 'Are you sure you want to delete this item?';

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: DeleteConfirmationData
  ) {
    if (data?.displayText) {
      this.displayText = data.displayText;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
